/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Dressing_RoomInputs */

const cs_enum_dressing_room = /** @type {(inputs: Enum_Dressing_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šatna`)
};

const en_enum_dressing_room = /** @type {(inputs: Enum_Dressing_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dressing room`)
};

/**
* | output |
* | --- |
* | "Dressing room" |
*
* @param {Enum_Dressing_RoomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_dressing_room = /** @type {((inputs?: Enum_Dressing_RoomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Dressing_RoomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_dressing_room(inputs)
	return cs_enum_dressing_room(inputs)
});